import React from 'react';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Hors du routeur : la langue se lit directement dans l'adresse.
            const english = /^\/en(\/|$)/.test(window.location.pathname);
            return (
                <div className="min-h-screen flex items-center justify-center">
                    <div className="text-center max-w-md px-6">
                        <div className="w-16 h-16 rounded-full bg-[hsl(var(--brand-rose))]/40 flex items-center justify-center mx-auto mb-6">
                            <span className="text-2xl">🧸</span>
                        </div>
                        <h1 className="font-serif text-2xl text-[hsl(var(--primary))] mb-3">{english ? 'Oops, something broke!' : 'Oups, quelque chose s’est cassé !'}</h1>
                        <p className="font-sans text-sm text-[hsl(var(--muted-foreground))] mb-6">
                            {english ? 'Don’t worry, our cuddly friends are fixing it. Try reloading the page.' : 'Ne vous inquiétez pas, nos amis tout doux sont en train de réparer. Essayez de recharger la page.'}
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            className="rounded-full bg-primary text-primary-foreground font-sans font-medium px-6 py-2.5 shadow-[var(--shadow-soft)] hover:shadow-[var(--shadow-ambient)] transition-all duration-200"
                        >
                            {english ? 'Reload the page' : 'Recharger la page'}
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
